import React from 'react';
import { observer } from 'mobx-react';
import { MeasureAreaToolView } from './MeasureAreaToolView';
import { MeasureDistanceToolView } from './MeasureDistanceToolView';
import { MeasureClearCommandView } from './MeasureClearCommandView';
import { MeasureResultsModel } from './MeasureResultsModel';
import { MapViewInputManager } from 'cd-eft/business/MapViewInputManager/MapViewInputManager';
import { OnChangeMeasureToolHandler } from 'cd-eft/business/MapViewInputManager/MeasureInputResult';
import { ISelectedMeasurementUnits } from './MeasureToolboxView';

interface IMeasureToolsetViewProps {
  inputManager: MapViewInputManager;
  measureResults: MeasureResultsModel;
  onChangeMeasureTool: OnChangeMeasureToolHandler;
  selectedMeasurementUnits: ISelectedMeasurementUnits;
}

export const MeasureToolsetView = observer(function (props: IMeasureToolsetViewProps) {
  return (
    <div className="widget-button-set">
      <MeasureDistanceToolView
        inputManager={props.inputManager}
        measureResults={props.measureResults}
        onChangeMeasureTool={props.onChangeMeasureTool}
        measurementUnit={props.selectedMeasurementUnits}
      />
      <MeasureAreaToolView
        inputManager={props.inputManager}
        measureResults={props.measureResults}
        onChangeMeasureTool={props.onChangeMeasureTool}
        measurementUnits={props.selectedMeasurementUnits}
      />
      <MeasureClearCommandView measureResults={props.measureResults} />
    </div>
  );
});
